var _g, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOneLabel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_22506",
    "data-name": "Group 22506",
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.533,
    height: 45.774,
    viewBox: "0 0 46.533 45.774",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_21682",
    "data-name": "Group 21682",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50765",
    "data-name": "Path 50765",
    d: "M338.616,469.2c6.273-.014,12.532-.15,18.8-.45l2.345-.123c5.059.273,9.791-4.214,9.232-9.218-.518-7.036-1-14.1-1.309-21.15a7.03,7.03,0,0,0-6.845-7.582q-9.409,0-18.8-.436l-2.345-.123a7.867,7.867,0,0,0-9.218,7.05c-.464,6.273-.886,12.532-1.2,18.8-.027,1.555-.232,3.164-.109,4.664a9.585,9.585,0,0,0,9.45,8.563Zm0,0a10.183,10.183,0,0,1-9.954-8.5c-.218-1.623-.191-3.15-.286-4.732-.314-6.273-.736-12.532-1.2-18.8a11.809,11.809,0,0,1,4.527-9.914,13.11,13.11,0,0,1,8.018-2.618l2.345-.123q9.409-.45,18.8-.436a12.923,12.923,0,0,1,12.736,14.168l-.109,2.345c-.314,6.273-.736,12.532-1.2,18.8a11.541,11.541,0,0,1-1.6,5.127,11.126,11.126,0,0,1-10.909,5.236l-2.345-.123c-6.3-.286-12.559-.423-18.832-.436Z",
    transform: "translate(-327.154 -424.079)",
    fill: "#fff"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "_1",
    "data-name": 1,
    transform: "translate(20.532 32.467)",
    fill: "#fff",
    fontSize: 25,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneLabel);
export default __webpack_public_path__ + "static/media/one_label.0a881b76693149443211bd8483afe9b8.svg";
export { ForwardRef as ReactComponent };